module.exports = __webpack_public_path__ + "static/media/avatarnew.3748cfba.png";